import { FunctionFactory } from 'survey-core';
import { TimeAvailable } from '../quiz/timeAvailable';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const timeAvailableSplashHtml = locHtml((t) => `
<div class="new-quote-container centered"> 
  <div class="splash-icon">‍🤸‍♂️️</div>
  <div class="splash-header">
    <h1>${t("splash.timeAvailable.title")}</h1>
    <div class="quote">
      ${t("splash.timeAvailable.text")}
    </div>
  </div>
</div>`);

const timeAvailableSplashExpression = {
  name: "timeAvailableQuote",
  expression: "renderTimeAvailableQuote({timeAvailable})",
};

function renderTimeAvailableQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (String(params[0]) as TimeAvailable) {
    case TimeAvailable.SixtyMinutes:
    case TimeAvailable.NinetyMinutes: {
      return `Awesome! That's more than enough time. If you're ever short on time, we'll also give you "time-saving workouts" that'll get you the same gains in far less time (30 minutes or less).`;
    }
    case TimeAvailable.ThirtyMinutes:
    case TimeAvailable.FourtyFiveMinutes:
    default: {
      return `No problem! We use science to make shorter workouts (some as quick as 15 minutes) just as effective as longer ones.`;
    }
  }
}

FunctionFactory.Instance.register("renderTimeAvailableQuote", renderTimeAvailableQuote);

const timeAvailableSplashElement = {
  name: 'time-available-splash',
  type: 'html',
  html: timeAvailableSplashHtml,
};

const TimeAvailableSplashHeader = makeSplashHeader("splash.headers.timeAvailable");

export {
  timeAvailableSplashElement,
  timeAvailableSplashExpression,
  TimeAvailableSplashHeader,
}
